import { useCallback, useEffect, useState } from 'react';

const fsElement = () => document.fullscreenElement || document.webkitFullscreenElement;

/** Whole-document full screen, for a rail's Full screen tab. Mirrors FullscreenToggle's behaviour. */
export default function useFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(() => !!fsElement());
  useEffect(() => {
    const onChange = () => setIsFullscreen(!!fsElement());
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);
    return () => {
      document.removeEventListener('fullscreenchange', onChange);
      document.removeEventListener('webkitfullscreenchange', onChange);
    };
  }, []);
  const toggle = useCallback(() => {
    if (fsElement()) (document.exitFullscreen || document.webkitExitFullscreen)?.call(document);
    else {
      const el = document.documentElement;
      (el.requestFullscreen || el.webkitRequestFullscreen)?.call(el);
    }
  }, []);
  return { isFullscreen, toggle };
}
